import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'htmlToString'
})
export class HtmlToStringPipe implements PipeTransform {
    transform(value: any): string {
        const temp = document.createElement('div');

        value = value.replaceAll('<br/>', '\n');
        value = value.replaceAll('<br />', '\n');

        temp.innerHTML = value;
        return temp.textContent || temp.innerText || '';
    }
}
